import { Component } from '@angular/core';
import { Nav, IonicPage, NavController, NavParams } from 'ionic-angular';
import { HomePage } from '../home/home';
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';

@IonicPage()
@Component({
  selector: 'page-intro-slider',
  templateUrl: 'intro-slider.html'
})
export class IntroSliderPage {
  slides: Array<{ id: number; description: string, image: string }>;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public nav: Nav,
    private http: HttpClient,
    private appConfig: AppConfigProvider
  ) {

    this.slides = [];

    this.http
      .post(this.appConfig.apiUrl() + 'index.php/api/landing/list', {
        token: 'token',
        app_key: this.appConfig.appKey()
      })
      .subscribe(
        (res: any) => {
          let data = res;
          for (let slide of data) {
            console.log(slide);
            let temp = {
              id: slide.id,
              title: slide.title,
              description: slide.description,
              image: slide.attachments
            };

            this.slides.push(temp);
          }
        },
        err => {
          console.log('Error request' + JSON.stringify(err));
        }
      );
  }

  skip() {
    // this.nav.push(HomePage);
    this.nav.setRoot(HomePage);
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/intro-slider/intro-slider.ts